<template>
	<md-table-row @click="set">
		<!-- <md-table-cell>{{ body.id }}</md-table-cell> -->
		<md-table-cell>{{ body.id }}</md-table-cell>
		<md-table-cell>{{ body.created_type }}</md-table-cell>
		<md-table-cell>{{ body.jp }}</md-table-cell>
		<md-table-cell>{{ body.en }}</md-table-cell>
		<md-table-cell v-if="is_model">{{ body.model_index }}</md-table-cell>
		<!-- <md-table-cell v-if="is_model">{{ body.ios_icon }}</md-table-cell>
		<md-table-cell v-if="is_model">{{ body.web_icon }}</md-table-cell> -->
		<md-table-head v-if="is_popular">
			<!-- {{ body.highly_recommeded }} -->
			<!-- <md-field>
				<md-select v-model="highly_recommeded_val" name="highly_recommeded" placeholder="highly_recommeded">
					<md-option value="0">0</md-option>
					<md-option value="1">1</md-option>
				</md-select>
			</md-field> -->
			<select v-model="highly_recommeded_val" name="name" id="name">
				<option value="0">0</option>
				<option value="1">1</option>
			</select>
		</md-table-head>
		<md-table-cell v-if="is_model_or_popular">{{ body.sepcial_domains }}</md-table-cell>
		<md-table-cell v-if="is_model_or_popular">{{ body.sepcial_keywords }}</md-table-cell>
		<md-table-cell>{{ body.used_count }}</md-table-cell>
	</md-table-row>
</template>
<script>

export default {
	name: 'DefaulTag',
	props: {
		body: {
			type: Object,
			required: true
		},
	},
	computed: {
		is_model: function () {
			return this.$store.getters['default_tags/is_model']
		},
		is_model_or_popular: function () {
			return this.$store.getters['default_tags/is_model_or_popular']
		},
		is_popular: function () {
			return this.$store.getters['default_tags/is_popular']
		},
		highly_recommeded_val: {
			get () {
				return String(this.body.highly_recommeded)
			},
			set (new_val) {
				console.log(new_val);
				const val = Number(new_val)
				this.$store.dispatch('default_tags/update_highly_recommeded', {id: this.body.id, highly_recommeded: val})
			},
		}
	},
	data() {
		return {
		};
  	},
  	methods: {
		set() {
			this.$store.commit('default_tags/set_selected', this.body.id)
		},
	},
}
</script>
<style scoped>

</style>
